import '../App.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams  } from "react-router-dom";
import SwiperCore, { Navigation, Autoplay } from 'swiper';

import { ethers } from "ethers"
import { WagmiConfig, createClient, chain, useAccount, useSwitchNetwork } from "wagmi";
import { ConnectKitProvider, ConnectKitButton, getDefaultClient } from "connectkit";
import { alchemyProvider } from 'wagmi/providers/alchemy'

import axios from 'axios';

import { CrossmintPayButton } from "@crossmint/client-sdk-react-ui";

function App() {

    const [searchParams] = useSearchParams();
  const [addressForMutation] = useState(searchParams.get("address"));

  /* global BigInt */

  const navigate = useNavigate();

  const [mintvalue, setMintValue] = useState('');
  const [glassvalue, setGlassToken] = useState('');
  const [voucher, setVoucher] = useState('');
  const [addr, setAddress] = useState('');
  const [totalGenesis, setTotalGenesis] = useState('');
  const [mintvalueReserved, setMintValueReserved] = useState('');
  const [mode, setMode] = useState('');

  const alchemyId = 'uY4eHA9TUYaqCjKOmFT-4_SrEWz4cGEv';
   
  const chains = [chain.mainnet];

  const client = createClient(
      getDefaultClient({
          appName: "ROTA",
          alchemyId,
          chains,
      })
  );

  const loadConnect = () => {
    document.getElementById("rota-reserved-mint").style.display="none";
  }

  const Connected = () => {

    useAccount({
        async onConnect({ address }) {
          setAddress(address)
          getStats(address);
          return
        },
        onDisconnect() {
          navigate('/');
          return
        },
    })
  }

const contract = {
    address: "0xDfB29501b42f63A947Ddc5249F185D6BcBE6986f",
    abi: [
        "function genesisMint(uint16 genesisId, uint16 lookingGlassId) public nonReentrant",
        "function totalSupply() external view returns (uint256)",
        "function genesisMinted(uint16) external view returns (bool)"
      ]
};

const genesisContract = {
  address: "0x7CB90567a118cd9F6CA326067A0813b289bdCb54",
  abi: [
      "function balanceOf(address account) external view returns (uint256)",
      "function ownerOf(uint256 tokenId) public view override returns (address)",
      "function tokenOfOwnerByIndex(address owner, uint256 index) external view returns (uint256 tokenId)"
    ]
};

const mutationGlass = {
  address: "0x775D576F54901B4bf23CB66B21dD14343c8AF888",
  abi: [
      "function balanceOf(address account, uint256 id) external view returns (uint256)",
  ]
};

useEffect(() => {
  if(addressForMutation ===  null || addressForMutation === undefined | addressForMutation.length !== 42){
    navigate("/mutate")
  }
  else{
  getTokens(addressForMutation);
  }
}, []);


async function getTokens(address){
  const RPC = "https://eth-mainnet.g.alchemy.com/v2/uY4eHA9TUYaqCjKOmFT-4_SrEWz4cGEv";
  const provider = new ethers.providers.JsonRpcProvider(RPC);

  const CONTRACT_ADDRESS = new ethers.Contract(genesisContract.address, genesisContract.abi, provider);
  const CONTRACT_ADDRESS_MUTATION = new ethers.Contract(contract.address, contract.abi, provider);

  var bal = await CONTRACT_ADDRESS.balanceOf(address);

  if(bal < 1){
    navigate("/mutate")
  }

  const apes = [];

  for(var i =0; i< bal; i++){

    var indexToken = await CONTRACT_ADDRESS.tokenOfOwnerByIndex(address,i);
    var token = Number(BigInt(indexToken));
    var minted = await CONTRACT_ADDRESS_MUTATION.genesisMinted(token);

        if(!minted){
            document.getElementById("number-input").innerHTML += 
            `<option style="color:black" value=` +  token + `>` +  token  + `</option>`
        
      }
  }



    document.getElementById("loading-tokens").innerHTML = "Select Genesis Token #"
    document.getElementById("number-input").classList.remove("disabled-events")

}

async function getStats(address) {

  const RPC = "https://eth-mainnet.g.alchemy.com/v2/uY4eHA9TUYaqCjKOmFT-4_SrEWz4cGEv";
  const provider = new ethers.providers.JsonRpcProvider(RPC);

  const MUTATION_ADDRESS = new ethers.Contract(mutationGlass.address, mutationGlass.abi, provider);

  var bal1 = await MUTATION_ADDRESS.balanceOf(address,1);
  var bal2 = await MUTATION_ADDRESS.balanceOf(address,2);
  var bal69 = await MUTATION_ADDRESS.balanceOf(address,69);

  var tr = Number(BigInt(bal1)) +  Number(BigInt(bal2)) +   Number(BigInt(bal69))

  setTotalGenesis(tr)

  // document.getElementById("amount-of-reserve").innerHTML  = tr;
  document.getElementById("bal1").innerHTML  = Number(BigInt(bal1));
  document.getElementById("bal2").innerHTML  = Number(BigInt(bal2));
  document.getElementById("bal69").innerHTML  = Number(BigInt(bal69));

  if(Number(BigInt(bal1)) === 0) {
    document.getElementById("glass-1").classList.add("none")
    document.getElementById("glass-1-number").classList.add("none")
  }

  if(Number(BigInt(bal2)) === 0) {
    document.getElementById("glass-2").classList.add("none")
    document.getElementById("glass-2-number").classList.add("none")
  }
 
  if(Number(BigInt(bal69)) === 0) {
    document.getElementById("glass-69").classList.add("none")
    document.getElementById("glass-69-number").classList.add("none")
  }

}

const COST_PUBLIC = 59000000000000000;
const COST_PUBLIC_ETH = 0.059;

class transaction {
  constructor(contractAddress, chainId, signer) {
      this.contractAddress = contractAddress;
      this.chainId = chainId;
      this.signer = signer;
  }

  static async mutate() {

      const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
      await provider.send("eth_requestAccounts", []);
      const signer = provider.getSigner();

      const connectedAddr = await signer.getAddress();

                  const hash = new ethers.Contract(contract.address, contract.abi, signer);
                  const tx = await hash.genesisMint(mintvalue,glassvalue);
                  // document.getElementById("eligible-remove").style.display="none";
                  document.getElementById("mutation-module").style.display="none";
                  document.getElementById("mutation-minting").style.display=null;
                  document.getElementById("go-back-mutation").style.display="none";
                  document.getElementById("mint-button").classList.add("disabled")
                  document.getElementById("select").classList.add("disabled")
                  document.getElementById("number-input").style.pointerEvents = "none";
                  document.getElementById("looking-glass").style.pointerEvents = "none";
                  document.getElementById("mint-button").style.color="black";
                  document.getElementById("mint-button").innerHTML = "Mutating..."
                  document.getElementById("mint-button").removeAttribute("onclick")
                  const receipt = await tx.wait();
                  document.getElementById("mint-button").innerHTML = "Success!"
                  document.getElementById("mint-again").style.display = null;
                  getStats(connectedAddr);
      }
    }



const day = () => {
  document.getElementById("module").classList.remove("mint-page-night")
  document.getElementById("module").classList.add("mint-page-day")
}

const war = () => {
  document.getElementById("module").classList.add("mint-page-night")
  document.getElementById("module").classList.remove("mint-page-day") 
}


const goMintReserved = () => {
  document.getElementById("mint-button-reserved").innerHTML = "Mint " + mintvalueReserved + " (FREE)";
  document.getElementById("mint-button-reserved").style.display=null;
}

async function set(x){
  document.getElementById("looking-glass").style.display="none";

  if(x <  0){
    document.getElementById("number-input").value = "";
    document.getElementById("number-input").placeholder = "Enter > 1 Token";
  }
  else{
    setMintValue(x);
    document.getElementById("select").classList.remove("disabled");
  }
}

function setGlass(x){
    setGlassToken(x);
    if(x === 1){
      document.getElementById("looking-glass-name").innerHTML = "Nano Banana";
      document.getElementById("looking-glass-image").src = "1.png";
    }
    if(x === 2){
      document.getElementById("looking-glass-name").innerHTML = "Nano Bunch";
      document.getElementById("looking-glass-image").src = "2.png";
    }
    if(x === 69){
      document.getElementById("looking-glass-name").innerHTML = "Nano Crate";
      document.getElementById("looking-glass-image").src = "69.png";
    }
    document.getElementById("input-genesis-group").style.display="none";
    document.getElementById("looking-glass").style.display="none";
    document.getElementById("mutation-module").style.display=null;
    document.getElementById("mint-button").innerHTML = "Mutate Genesis #" + mintvalue;
    document.getElementById("mint-button").style.display=null;
    document.getElementById("go-back-mutation").style.display=null;
}

async function goGlass () {


if(mintvalue > 4443 || mintvalue < 1){
  document.getElementById("number-input").value = "";
  document.getElementById("number-input").placeholder = "Genesis does not exist";
}
else{

  const RPC = "https://eth-mainnet.g.alchemy.com/v2/uY4eHA9TUYaqCjKOmFT-4_SrEWz4cGEv";
  const provider = new ethers.providers.JsonRpcProvider(RPC);

  const CONTRACT_ADDRESS = new ethers.Contract(contract.address, contract.abi, provider);
  const GENESIS_CONTRACT = new ethers.Contract(genesisContract.address, genesisContract.abi, provider);

  console.log(mintvalue);

  var minted = await CONTRACT_ADDRESS.genesisMinted(mintvalue);
  var isOwner = await GENESIS_CONTRACT.ownerOf(mintvalue);

  if(addr !== isOwner){
    document.getElementById("number-input").value = "";
    document.getElementById("number-input").placeholder = "You do not own this Genesis";
  }
  else{

    if(minted) {
      document.getElementById("number-input").value = "";
      document.getElementById("number-input").placeholder = "Genesis Already Mutated";
    }
  else{
    document.getElementById("number-input").classList.remove("disabled-events");
    document.getElementById("looking-glass").style.display=null;
    document.getElementById("genesis-id").innerHTML = mintvalue;
    getImage(mintvalue);
  }
}
}

}

async function getImage(token) {

  const options = {
    method: 'GET',
    url: 'https://api.opensea.io/api/v1/asset/0x7CB90567a118cd9F6CA326067A0813b289bdCb54/' + token + '/?include_orders=false',
    headers: {accept: 'application/json', 'X-API-KEY': '9dbb5b06fefd4582983b247d08cf90b0'}
  };

  axios
    .request(options)
    .then(async function (response) {
      document.getElementById("genesis-image").src = response.data.image_preview_url;
    })
    .catch(function (error) {
      console.error(error);
    });

}


  return (
  <main className="page-wrapper">

<header className="header navbar navbar-expand-lg bg-secondary shadow-sm shadow-dark-mode-none">
      <div className="container px-3">
        <a href="https://atsnft.io/" className="navbar-brand pe-3">
          <img src="ape.png" width={47} alt="Logo" />
        </a>
        <div id="navbarNav" className="offcanvas offcanvas-end">
          <div className="offcanvas-header border-bottom">
            <h5 className="offcanvas-title">Menu</h5>
            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
          </div>
          <div className="offcanvas-body">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
                <a href="https://records.atsnft.io/" className="nav-link text-nowrap">Records</a>
              </li>
              <li className="nav-item">
              <a href="https://mint.atsnft.io/" className="nav-link text-nowrap active" style={{color:"#e9ca7a"}}>ROTA Mint</a>
              </li>
              <li className="nav-item">
              <a href="https://marketplace.atsnft.io/" target="_blank" className="nav-link text-nowrap">Marketplace</a>
              </li>
              <li className="nav-item">
              <a href="https://warbonds.atsnft.io/" className="nav-link text-nowrap">War Bonds</a>
              </li>
              <li className="nav-item">
              <a href="https://war.atsnft.io/" className="nav-link text-nowrap">War</a>
              </li>
              <li className="nav-item">
              <a href="https://records.atsnft.io/tickets" className="nav-link text-nowrap">Tickets</a>
              </li>
              <a href="https://twitter.com/ATSNFT" target="_blank" className="btn btn-icon btn-secondary btn-twitter d-none rounded-circle mx-1 d-lg-inline-flex"><i className="bx bxl-twitter"></i></a>
             <a href="https://discord.com/invite/ATSNFT" target="_blank" className="btn btn-icon btn-secondary btn-discord d-none rounded-circle mx-1 d-lg-inline-flex"><i className="bx bxl-discord"></i></a>
             
            </ul>
          </div>
          <div className="offcanvas-header border-top">
          </div>      
        </div>
        <div className="form-check form-switch mode-switch pe-lg-1 ms-auto me-4"  >
        {/* <button className="btn btn-daytime" type="button" onClick={day} >Day</button>
        <button  className="btn btn-nighttime" type="button" onClick={war} >War</button> */}
        </div>
        <button type="button" className="navbar-toggler" data-bs-toggle="offcanvas" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon" />
        </button>
      </div>
    </header>

    <section id="module" className="mint-page-mutation" >

          <div id="rota-public-mint" className="row justify-content-center text-center pb-4 mb-2 mint-module">
            <div className="col-xl-12 col-lg-9 col-md-10">
              <br></br>
            <div style={{display:"none"}} className="connect-section py-4">
            <WagmiConfig client={client}>
      <ConnectKitProvider 
           theme="midnight"
      >
        <ConnectKitButton />
        <Connected />
      </ConnectKitProvider>
    </WagmiConfig>
            </div>
            <button id="go-back"  className="btn btn-secondary" type="button" onClick={e => navigate('/mutate')} >Go Back</button><br></br><br></br>

            {/* <div className="mint-text-small"> You have a mint pass!&nbsp;&nbsp;
            <button className="btn btn-primary" type="button" onClick={goMintPass} >Mint with Pass</button>
            </div> */}
         
         <section id="input-genesis-group" className="input-section col-xl-10 col-md-5 py-1" >
            {/* <div id="number-input-group" className="input-group mb-4">
                    <input id="number-input"  placeholder="Input Genesis Id #" type="number" className="form-select  mint-text-small" onChange={e => set(e.target.value)}/>
                    <button id="select"  className="btn btn-primary disabled" type="button" onClick={e => goGlass()} >Select Genesis</button>
              </div> */}
              <div id="number-input-group" className="input-group mb-4">

              <select id="number-input" className="form-select form-select-lg disabled-events" required=""  onChange={e => set(e.target.value)}>
                  <option id="loading-tokens" value="" selected="" disabled="">Loading Genesis Tokens...</option>
                </select>
                <button id="select"  className="btn btn-primary disabled" type="button" onClick={e => goGlass()} >Select Genesis</button>

                </div>

        </section>


      <section id="looking-glass" style={{display:"none"}} className="input-section col-xl-10 col-md-5" >
      <div  className="row justify-content-center text-center pb-4 mb-2">
      <div className="mint-text-large">Select Looking Glass Token:</div>
        <div className="col-xl-8 col-lg-9 col-md-10">
              <div onClick={e => setGlass(1)} id="glass-1" target="_blank" style={{height:"75px",width:"75px"}} className="btn btn-icon btn-secondary rounded-circle mx-1 d-lg-inline-flex"><img  src="1.png"></img></div>
              <div onClick={e => setGlass(2)} id="glass-2" target="_blank" style={{height:"75px",width:"75px"}} className="btn btn-icon btn-secondary rounded-circle mx-1 d-lg-inline-flex"><img  src="2.png"></img></div>
              <div onClick={e => setGlass(69)} id="glass-69" target="_blank" style={{height:"75px",width:"75px"}} className="btn btn-icon btn-secondary rounded-circle mx-1 d-lg-inline-flex"><img  src="69.png"></img></div>
          </div>  
          <div className="col-xl-8 col-lg-9 col-md-10" style={{height:"30px"}} >
              <div target="_blank" id="glass-1-number" style={{height:"75px",width:"75px"}} className="btn btn-icon  rounded-circle mx-1 d-lg-inline-flex"><span id="bal1"></span></div>
              <div target="_blank" id="glass-2-number" style={{height:"75px",width:"75px"}} className="btn btn-icon rounded-circle mx-1 d-lg-inline-flex"><span id="bal2"></span></div>
              <div target="_blank" id="glass-69-number" style={{height:"75px",width:"75px"}} className="btn btn-icon  rounded-circle mx-1 d-lg-inline-flex"><span id="bal69"></span></div>
          </div>   
     </div> 

     </section>

     <section style={{display:"none"}} id="mutation-minting"  className="input-section col-xl-10 col-md-5" >
      <div className="row row-cols-1 row-cols-sm-1 gx-3 gx-lg-4">
 
        <div className="connect-section col pb-lg-2 mb-4"  style={{height:"auto",width:"400px"}} >
          <article className="card h-100 border-0 shadow-sm">
            <div className="position-relative">
              <img  src="mutate.gif" style={{objectFit:"cover"}} className="card-img-top" alt="Image" />
            </div>
          </article>
        </div>

      </div>

      </section>
     

      <section id="mutation-module" style={{display:"none"}} className="input-section col-xl-10 col-md-5" >
      <div className="row row-cols-1 row-cols-sm-2 gx-3 gx-lg-4">
 
        <div className="connect-section col pb-lg-2 mb-4"  style={{height:"250px",width:"250px"}} >
          <article className="card h-100 border-0 shadow-sm">
            <div className="position-relative">
              <img id="genesis-image" src="ape.png" className="card-img-top" alt="Image" />
            </div>
            <div className="card-body pb-3">
              <h3 className="h5 mb-2">
                Genesis #<span  id="genesis-id"></span>
              </h3>
            </div>
          </article>
        </div>
        <div className="connect-section col pb-lg-2 mb-4"  style={{height:"250px",width:"250px"}} >
          <article className="card h-100 border-0 shadow-sm">
            <div className="position-relative">
              <img id="looking-glass-image" src="ape.png" className="card-img-top" alt="Image" />
            </div>
            <div className="card-body pb-3">
              <h3 className="h5 mb-2">
              <span  id="looking-glass-name"></span>
              </h3>
            </div>
          </article>
        </div>

      </div>

      </section>


            <button style={{display:"none",margin:"5px"}}  id="mint-button" className="btn btn-primary btn-connect about-us" onClick={e => transaction.mutate()} >Mint</button>
            <button style={{display:"none",margin:"5px"}}  id="go-back-mutation" className="btn btn-secondary btn-connect about-us" onClick={e => window.location.reload()} >Go Back</button>
            <button style={{display:"none",margin:"5px"}}  id="mint-again" className="btn btn-secondary btn-connect about-us" onClick={e => window.location.reload()} >Mint Again</button>
            <CrossmintPayButton
                className="btn btn-secondary btn-connect about-us xmint-btn"
                id="mint-button-credit-card"
                style={{display:"none",margin:"5px"}}
                clientId="43d95c1a-0bd1-467c-84cb-a78e5311c8dd"
                mintConfig={{
                  "type":"erc-721",
                  "totalPrice":String(mintvalue*COST_PUBLIC_ETH),
                  "_tokenAmount":mintvalue,
                  "isCrossmint":true
                }}
                
                mintTo={addr}
            />
   
            </div> 
            <div className="col-xl-8 col-lg-9 col-md-10">
              <br></br>
            <a href="https://etherscan.io/address/0xdfb29501b42f63a947ddc5249f185d6bcbe6986f" target="_blank" className="btn btn-icon btn-secondary btn-facebook rounded-circle mx-1 d-lg-inline-flex"><img style={{height:"20px"}} src="etherscan.png"></img></a>
            <a href="https://opensea.io/collection/rotanft" target="_blank" className="btn btn-icon btn-secondary btn-twitter rounded-circle mx-1 d-lg-inline-flex"><img style={{height:"25px"}} src="opensea.png"></img></a>
            <a href="https://atsnft.io/terms-of-sale/" target="_blank" className="btn btn-secondary btn-google mx-1 d-lg-inline-flex">Terms of Sale</a>
            </div>       
          </div>

          <div style={{display:"none"}} id="rota-reserved-mint" className="row justify-content-center text-center pb-4 mb-2 mint-module">
            <div className="col-xl-12 col-lg-9 col-md-10">
            <div className="mint-text-small">All Mint passes must be used by:</div>
            <div className="mint-text-small">March 1st 2023 @ 8pm EST</div><br></br>
            <div>
            <button className="btn btn-primary" type="button" onClick={loadConnect} >Go Back</button>
            </div>
         
         <section className="input-section col-xl-6 col-md-5 py-3" >
            <div className="input-group mb-4">
                    <select className="form-select" onChange={e => setMintValueReserved(e.target.value)}>
                      <option selected disabled>Choose Mint Amount</option>
                      <option value="1" style={{color:"black"}}>1 (FREE)</option>
                      <option value="2" style={{color:"black"}}>2 (FREE)</option>
                    </select>
                    <button className="btn btn-primary" type="button" onClick={goMintReserved} >Select</button>
              </div>
      </section>

            <button style={{display:"none"}} id="mint-button-reserved" className="btn btn-secondary btn-connect about-us" >Mint</button>
       </div> 
       <div className="col-xl-8 col-lg-9 col-md-10">
            <a href="https://etherscan.io/address/0xdfb29501b42f63a947ddc5249f185d6bcbe6986f" target="_blank" className="btn btn-icon btn-secondary btn-facebook rounded-circle mx-1 d-lg-inline-flex"><img style={{height:"20px"}} src="etherscan.png"></img></a>
            <a href="https://opensea.io/collection/rotanft" target="_blank" className="btn btn-icon btn-secondary btn-twitter rounded-circle mx-1 d-lg-inline-flex"><img style={{height:"25px"}} src="opensea.png"></img></a>
            <a href="https://atsnft.io/terms-of-sale/" target="_blank" className="btn btn-secondary btn-google mx-1 d-lg-inline-flex">Terms of Sale</a>
            </div>      
          </div>


</section>
</main>

  );
}

export default App;